module.exports = __webpack_public_path__ + "static/media/purewatt-1.13d704c7.jpg";